
import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import HomePage from '../pages/home/page';
import NewsPage from '../pages/news/page';
import NewsDetailPage from '../pages/news/detail/page';
import AdminPage from '../pages/admin/page';
import LoginPage from '../pages/login/page';
import NotFound from '../pages/NotFound';

// Componente para proteger la ruta admin
const ProtectedAdminRoute = ({ children }: { children: React.ReactNode }) => {
  const isAdmin = localStorage.getItem('isAdmin');
  
  if (!isAdmin) {
    return <Navigate to="/login" replace />;
  }
  
  return <>{children}</>;
};

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/news/:id',
    element: <NewsDetailPage />,
  },
  {
    path: '/noticias',
    element: <NewsPage />,
  },
  {
    path: '/noticias/:id',
    element: <NewsDetailPage />,
  },
  {
    path: '/admin',
    element: (
      <ProtectedAdminRoute>
        <AdminPage />
      </ProtectedAdminRoute>
    ),
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
